import {ErrorCodesFilters} from "@/models/Enums";

export class GetDeviceCodeFaultsRequest{
    public deviceExternalId : string  | undefined = "";
    
    public period : ErrorCodesFilters = ErrorCodesFilters.RentalPeriod;
}